import { Button, TableItem } from 'components/atoms';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useTranslation } from 'react-i18next';
import { PiSelectionPlus } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetContractTemplates } from 'services/templates/contract-template';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { useRowSelect } from "@table-library/react-table-library/select";
import { Action, State } from "@table-library/react-table-library/types/common";
import { DefaultError } from "@tanstack/react-query";
import LabelNotificationStatus from "components/molecules/labeledStatus/LabelNotificationStatus";
import { useComponentVisible, useHasPermission } from "hooks";
import { useTableColumnsVisibility } from "hooks/useTableColumnsVisibility";
import { usePermissionGuard } from "hooks/usePermissionGuard";
import { useStoreState } from "providers/StoreStateContext";

const ContractTemplates = () => {
  usePermissionGuard('ContractTemplatePermissionsLIST**');
  const hasPermission = useHasPermission();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const templates = useGetContractTemplates();

  const tableProps = useInfiniteTable(templates, {
    customPath: id => `contract/${id}/form`,
    selectable: true,
  });

  // const { getSelectOptions } = useEnumToSelectOptions();

  // const { ref, isComponentVisible, handleComponentVisible } =
  //   useComponentVisible<HTMLDivElement>(false);

  const i18nextPrefix = 'contract-template.list';

  // const goToAgreementTemplate = (id = 'create') => navigate(`agreement/${id}`);

  // const goToCustomSectionTemplate = (id = 'create') =>
  //   navigate(`section/${id}`);

  // const goToDigitalDistributionSectionTemplate = (id = 'create') =>
  //   navigate(`digital-distribution/${id}`);
  // const goToPhysicalDistributionSectionTemplate = (id = 'create') =>
  //   navigate(`physical-distribution/${id}`);

  const goToContractTemplate = (id = 'create') => navigate(`contract/${id}/form`);

  // const goToCreateTemplate = (type: TEMPLATE_TYPE) => {
  //   type === TEMPLATE_TYPE.agreement && goToAgreementTemplate();

  //   type === TEMPLATE_TYPE.section && goToCustomSectionTemplate();

  //   type === TEMPLATE_TYPE.digitalDistribution &&
  //     goToDigitalDistributionSectionTemplate();

  //   type === TEMPLATE_TYPE.physicalDistribution &&
  //     goToPhysicalDistributionSectionTemplate();

  //   type === TEMPLATE_TYPE.contract && goToContractTemplate();
  // };

  // const goToTemplate = (type: TEMPLATE_TYPE, id: string) => {
  //   type === TEMPLATE_TYPE.agreement && goToAgreementTemplate(id);

  //   type === TEMPLATE_TYPE.section && goToCustomSectionTemplate(id);

  //   type === TEMPLATE_TYPE.digitalDistribution &&
  //     goToDigitalDistributionSectionTemplate(id);

  //   type === TEMPLATE_TYPE.physicalDistribution &&
  //     goToPhysicalDistributionSectionTemplate(id);

  //   type === TEMPLATE_TYPE.contract && goToContractTemplate(id);
  // };

  // const buttonStyle = { justifyContent: 'start' };

  return (
    <TopbarPage
      topbar={
        <TopBar
          title={t(`${i18nextPrefix}.title`)}
          path=''
          hideBackButton
          topbarContent={
            // <Button
            //   variant={BUTTON_VARIANT.submit}
            //   onClick={handleComponentVisible}
            //   outsideChildren={
            //     <DropdownMenu
            //       ref={ref}
            //       visible={isComponentVisible}
            //       style={{ padding: 0 }}
            //       justifyPosition={'end'}>
            //       <div className='flex flex-col w-full'>
            //         {getSelectOptions(TEMPLATE_TYPE).map(template => (
            //           <Button
            //             isClear
            //             onClick={() => goToCreateTemplate(template.value)}
            //             buttonStyle={buttonStyle}
            //             fullWidth>
            //             <Button.Text
            //               text={t(
            //                 `enum.TEMPLATE_TYPE.${
            //                   TEMPLATE_TYPE[template.value]
            //                 }`
            //               )}
            //             />
            //           </Button>
            //         ))}
            //       </div>
            //     </DropdownMenu>
            //   }>
            //   <Button.Text text={t(`${i18nextPrefix}.addTemplate`)} />
            //   <Button.Icon icon={<PiSelectionPlus />} />
            // </Button>
            <>
            {hasPermission('ContractTemplatePermissionsLIST**', 1) && (
              <Button
                variant={BUTTON_VARIANT.submit}
                onClick={() => goToContractTemplate()}>
                <Button.Text text={t(`${i18nextPrefix}.createTemplate`)} />
                <Button.Icon icon={<PiSelectionPlus />} />
              </Button>
            )}
            </>
          }></TopBar>
      }>
      <Table
        id={"ContractTemplates"}
        {...tableProps}
        displayMode
        columns={[
          {
            label: t(`input.label.title`),
            renderCell: ({ title }) => (
              <TableItem>
                <TableItem.Text text={title} />
              </TableItem>
            ),
          },
          // {
          //   label: t(`input.label.type`),
          //   renderCell: ({ type }) => (
          //     <TableItem>
          //       {t(`enum.TEMPLATE_TYPE.${TEMPLATE_TYPE[type.id]}`)}
          //     </TableItem>
          //   ),
          // },
        ]}
      />
    </TopbarPage>
  );
};

export default ContractTemplates;
